import { IReportTamThuRequest } from "../../../model/request/report/IReportTamThuRequest";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import { IReportTamThuViewModel } from "../../../model/respone/report/IReportTamThuRespone";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eReportTamThuActionsObj = {
  LOAD_START: {} as IReportTamThuRequest,
  LOAD_SUCCESS: {} as IPagingResult<IReportTamThuViewModel[]>,
  LOAD_ERROR: {} as string,

  CHANGE_REQUEST: {} as any,
  SHOW_MODAL_LIST_BIEN_LAI: "",
  CLOSE_MODAL_LIST_BIEN_LAI: undefined,

  SHOW_HIDE_FILTER: {} as boolean,
};
export const eReportTamThuActionIds = generateActionTypeIds(
  eReportTamThuActionsObj,
  "REPORT_TAM_THU"
);
export type IReportTamThuActionTypes = IGenericActionType<
  typeof eReportTamThuActionsObj,
  "REPORT_TAM_THU"
>;
